/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-23 17:16:46
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-05-01 21:51:59
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorButton/index.tsx
 */
import { Button } from '@/src/components/Antd';
import RouteBlock from '@/src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC/RouteBlock';
import ErrorProcessingComponent from '@/src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC/ErrorProcessingComponent';
import { RightConfigWrapper } from '@/src/layout';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import { PlusOutlined } from '@ant-design/icons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dispatch } from 'src/store';
import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import Item from './Item';
import Preview from './Preview';
import {
  fetchButton,
  getButton,
  getButtons,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getSubmitStamp,
  onAddButton,
  onCollapseOpen,
  onDelete,
  onDuplicate,
  onErrorChange,
  submitButton,
  validation,
} from './slice';
import styles from './css.module.less';
import { buttonValidation, convertDataFromReduxToServer } from './tool';
import { PreviewWrapper } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import PreviewContainer from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';

function SalesChannelEditorButton(props: any) {
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    isOnPrimaryLanguage,
  } = props;
  const _d = useDispatch();
  const buttons = useSelector(getButtons());
  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      <PageWrapper
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName: salesChannelName,
          onDiscard,
          onGoBack,
        }}
        leftChild={
          <PreviewWrapper>
            <PreviewContainer wrapperClassName={styles.previewContainer}>
              <Preview />
            </PreviewContainer>
          </PreviewWrapper>
        }
        rightChild={
          <RightConfigWrapper
            title={'Button'}
            elements={[
              {
                body: (
                  <React.Fragment>
                    <div className={styles.buttonContainer}>
                      <Button
                        size={'large'}
                        type={'primary'}
                        block
                        className={styles.button}
                        icon={<PlusOutlined className={styles.icon} />}
                        onClick={() => _d(onAddButton({}))}>
                        {'New Button'}
                      </Button>
                    </div>
                    {buttons.map((button) => {
                      return (
                        <ErrorProcessingComponent
                          key={button.uuid}
                          getCollapseOpenStatus={getCollapseOpenStatus}
                          onCollapseOpen={onCollapseOpen}
                          headerProps={{
                            dotsFunction: [
                              {
                                onClick: () => {
                                  _d(onDuplicate({ uuid: button.uuid }));
                                },
                                key: 'Duplicate',
                                body: 'Duplicate',
                              },
                              {
                                key: 'Delete',
                                body: 'Delete',
                                isDangerous: true,
                                displayWarningModal: true,
                                onClick: () => void 0,
                                modalOnOk: () => {
                                  _d(onDelete({ uuid: button.uuid }));
                                },
                                modalTitle: 'Delete Button',
                                modalContent: 'Are you sure to delete button ?',
                              },
                            ],
                            hasDots: true,
                            hideDotsWhenNotPrimary: true,
                          }}
                          id={`${button.uuid}`}
                          getContent={() => getButton(button.uuid)}
                          title={button.name}
                          getErrorDisplay={getCollapseValidationMsgDisplay}
                          onErrorChange={onErrorChange}
                          validation={(x, _p) => {
                            return buttonValidation(x);
                          }}
                          getSubmitStamp={getSubmitStamp}
                          renderComponent={(errorProcessingProps: any) => (
                            <Item
                              isOnPrimaryLanguage={isOnPrimaryLanguage}
                              button={button}
                              errorProcessingProps={errorProcessingProps}
                            />
                          )}
                        />
                      );
                    })}
                  </React.Fragment>
                ),
                key: 'headerTop',
              },
            ]}
          />
        }
      />
    </React.Fragment>
  );
}

export default BasicPageHOC(SalesChannelEditorButton, {
  getState,
  previewSizeInParams: true,
  convertDataFromReduxToServer,
  submit: submitButton,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  getLoaded,
  validation,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchButton({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
